import styled from 'styled-components';
import { FormControlLabel } from '@mui/material';
import { Styling, Colors, Animations } from '../../../constants';
import { VaultButton } from '../../Shared';

export const QueryResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  position: relative;
  padding: ${Styling.DEFAULT_SPACING}px;
`;

// NOTE: search result page style patch, to be iterated
export const ResultDetailsContainer = styled.div`
  width: 100%;
  min-width: 612px;
  display: flex;
  padding-bottom: ${Styling.DEFAULT_SPACING_HALVED}px;
  background-color: rgba(255, 255, 255, 1);
  justify-content: space-between;
  align-items: center;
`;

export const TableAndPreviewContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  position: relative;
  height: 1px; /* flexbox hack to take up rest of remaining vertical space & allow scrolling for preview panel */
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
  overflow-x: hidden;
`;

export const AssetDetailsDrag = styled.div`
  height: 56px;
  border-left: 2px solid ${Colors.BLACK_20};
  user-select: none;
  transition: height ${Animations.DEFAULT_TRANSITION}, border ${Animations.DEFAULT_TRANSITION};
`;

const dragHoverOrDraggingStyle = `
  cursor: ew-resize;
  background-color: ${Colors.PRIMARY_15};
  transition: background-color ${Animations.DEFAULT_TRANSITION};

  ${AssetDetailsDrag} {
    border-left: 2px solid ${Colors.PRIMARY_50};
    transition: height ${Animations.DEFAULT_TRANSITION}, border ${Animations.DEFAULT_TRANSITION};
  } 
`;

export const AssetDetailsDragContainer = styled.div<{ $isDragging?: boolean }>`
  display: flex;
  align-items: center;
  padding-left: ${Styling.DEFAULT_SPACING_HALVED - 2}px;
  padding-right: ${Styling.DEFAULT_SPACING_HALVED - 2}px;
  margin-left: ${Styling.DEFAULT_SPACING_HALVED}px;
  user-select: none;
  background-color: ${Colors.PAPER_DARKER_1};

  ${(props) => {
    if (props.$isDragging) {
      return dragHoverOrDraggingStyle;
    }

    return `
      &:hover {
        ${dragHoverOrDraggingStyle}
      }
    `;
  }}
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  flex-flow: space-between; 
`;

export const FilterButtonContainer = styled.div`
  display: flex;
  align-items: center;

  button {
    margin-left: ${Styling.DEFAULT_SPACING}px;
  }
`;

export const AdvancedFilterButtonContainer = styled.div`
  margin-left: 5px;
`;

export const ResultsActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  flex-grow: 1;
  margin-left: 50px;
`;

export const SocialButton = styled(VaultButton).attrs((props) => ({
  variant: 'primaryOnWhite',
}))`
  height: 42px;
`;

export const StyledControl = styled(FormControlLabel)`
  margin-left: -3px !important;
  margin-right: -${Styling.DEFAULT_SPACING_HALVED}px !important;
  .MuiFormControlLabel-label {
    font-size: 0.75rem;
  }
`;

export const ButtonSpacer = styled.span` 
  margin-right: ${Styling.DEFAULT_SPACING_HALVED}px;
`;

export const AddTagButton = styled(VaultButton).attrs((props) => ({
  variant: 'primaryOnWhite',
}))`
`;

export const SecurityProfileFilterContainer = styled.div`
  margin-top: 16px;
  width: 550px;
`;
